// Public form identifiers from the owner-provided Mailchimp embed, not API credentials.
export const mailchimpAction = 'https://yourhaven.us7.list-manage.com/subscribe/post?u=6b5b2f8a522afab31ca223130&id=3a7200d616&f_id=00d2c4e4f0';
const honeypot = 'b_6b5b2f8a522afab31ca223130_3a7200d616';
let requestId = 0;

export function buildMailchimpFields(signup, consentField) {
  // This embed subscribes contacts to email. Never silently subscribe an unchecked visitor.
  if (!signup.updatesConsent && !consentField) {
    throw new Error('A separate consent field is needed for optional newsletter signup.');
  }
  const fields = new URLSearchParams({
    EMAIL: signup.email, FNAME: signup.firstName, PHONE: signup.whatsapp || '',
    MMERGE7: signup.inSchool === 'yes' ? 'Yes' : signup.inSchool === 'no' ? 'No' : '',
    SCHOOL: signup.inSchool === 'yes' ? signup.school || '' : '',
    [honeypot]: '',
  });
  if (signup.birthday) {
    const { month, day } = signup.birthday;
    const maxDay = new Date(2000, Number(month), 0).getDate();
    if (!/^\d{1,2}$/.test(String(month)) || !/^\d{1,2}$/.test(String(day)) || Number(month) < 1 || Number(month) > 12 || Number(day) < 1 || Number(day) > maxDay) throw new Error('Invalid birthday');
    fields.set('BIRTHDAY[month]', String(month).padStart(2, '0'));
    fields.set('BIRTHDAY[day]', String(day).padStart(2, '0'));
  }
  if (consentField && signup.updatesConsent) fields.set(consentField.name, consentField.value);
  return fields;
}

// Mirrors the JSONP transport used by Mailchimp's own mc-validate.js embed.
// No jQuery, embed stylesheet or API key is loaded into the page.
export function submitMailchimpSignup(signup, consentField) {
  const fields = buildMailchimpFields(signup, consentField);
  return new Promise((resolve, reject) => {
    const callback = `havenMailchimp_${Date.now()}_${++requestId}`;
    const script = document.createElement('script');
    let timer;
    const cleanup = () => {
      clearTimeout(timer);
      script.remove();
      delete window[callback];
    };
    window[callback] = response => {
      cleanup();
      if (response?.result !== 'success') {
        const error = new Error('Mailchimp did not confirm registration.');
        error.canContinueOnMailchimp = response?.msg === 'captcha';
        error.userMessage = response?.msg === 'captcha'
          ? 'Mailchimp needs an extra verification step. Continue on Mailchimp to complete it.'
          : new DOMParser().parseFromString(String(response?.msg || ''), 'text/html').body.textContent;
        reject(error);
        return;
      }
      // A success can mean pending double opt-in. Display Mailchimp's actual message,
      // as plain text, before claiming the visitor is subscribed.
      const message = new DOMParser().parseFromString(String(response.msg || ''), 'text/html').body.textContent;
      resolve({ saved: true, confirmationMessage: message });
    };
    const url = new URL(mailchimpAction.replace('/post?', '/post-json?'));
    fields.forEach((value, key) => url.searchParams.set(key, value));
    url.searchParams.set('c', callback);
    script.src = url.toString();
    const fail = message => {
      cleanup();
      const error = new Error(message);
      error.canContinueOnMailchimp = true;
      error.userMessage = 'We couldn’t reach Mailchimp from this page. You can continue on Mailchimp to complete your signup.';
      reject(error);
    };
    script.onerror = () => fail('Mailchimp could not be reached.');
    timer = setTimeout(() => fail('Mailchimp request timed out.'), 15000);
    document.head.appendChild(script);
  });
}

// User-triggered native POST avoids the third-party script transport. Mailchimp
// displays validation, verification and the actual subscription outcome itself.
export function continueOnMailchimp(signup) {
  const fields = buildMailchimpFields(signup);
  const form = document.createElement('form');
  form.action = mailchimpAction;
  form.method = 'POST';
  form.target = '_blank';
  form.rel = 'noopener noreferrer';
  form.hidden = true;
  fields.forEach((value, name) => {
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = name; input.value = value;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  try { form.submit(); } finally { form.remove(); }
}
